<template>
  <div class="main-layout main-layout_fullpage">
    <div class="main-layout__head main-layout__head_pb24">
      <h2 class="main-title">Niederlassungen</h2>
    </div>

    <offices-list />

    <add-btn @onClick="openOfficesModal" />

    <modal :show="isShowModal" :dark="true" :outside="false" @close="closeOfficesModal">
      <offices-modal @close="closeOfficesModal" @done="onSaveOffice" />
    </modal>
  </div>
</template>

<script>
import officesList from '@/components/lists/offices/officesList'
import addBtn from '@/components/controls/addBtn'
import officesModal from '@/components/modals/offices/officesModal'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'offices',
    components: {
        officesList,
        addBtn,
        officesModal,
    },
    computed: {
        ...mapGetters({
            isShowModal: 'offices/isShowModal',
        }),
    },
    methods: {
        ...mapMutations({
            setState: 'offices/setState',
            setLink: 'setLink',
        }),
        ...mapActions({
            fetch: 'offices/fetch',
            add: 'offices/add',
            update: 'offices/update',
        }),
        openOfficesModal() {
            this.setState({
                key: 'office',
                data: {
                    address: null,
                    radius: 1000,
                    polygon: null,
                    latitude: null,
                    longitude: null,
                },
            })
            this.setState({
                key: 'isShowModal',
                data: true,
            })
        },
        closeOfficesModal() {
            this.setState({
                key: 'isShowModal',
                data: false,
            })
        },
        async onSaveOffice(data) {
            let isOkey
            if (!data.id) {
                isOkey = await this.add(data)
            } else {
                isOkey = await this.update(data)
            }

            if (!isOkey) return

            this.setState({
                key: 'isShowModal',
                data: false,
            })
            await this.fetch()
        },
    },
    mounted() {
        this.setLink({
            key: 'infoRootLink',
            value: 'https://doc.clickup.com/p/h/4hhzv-2181/8af4bf532559143/4hhzv-2181',
        })
        this.setLink({
            key: 'infoLink',
            value: 'https://doc.clickup.com/p/h/4hhzv-761/e3f256e38c7d87b',
        })
    },
    beforeDestroy() {
        this.setLink({
            key: 'infoRootLink',
            value: null,
        })
        this.setLink({
            key: 'infoLink',
            value: null,
        })
    },
}
</script>
